import type {
  ChangeFavoriteListModalPropsMicrocopy,
  FavoriteListModalPropsMicrocopy,
} from 'ui-components';

export const PRODUCT_LISTS_MICROCOPY_DEFAULTS = {
  'product-lists.multiple-lists': '{count} lists',
  'product-lists.added-to': 'Added to',
  'product-lists.removed-from': 'Removed from',
  'product-lists.view-list': 'View list',
  'product-lists.change-list': 'Change list',
  'product-lists.add-to-new-list': 'Add to new list',
  'product-lists.close': 'Close',
  // FavoriteListModal microcopy
  'product-lists.create-modal-title': 'New list',
  'product-lists.create-modal-subtitle': 'Create a new list',
  'product-lists.create-modal-name-label': 'New list name',
  'product-lists.create-modal-name-placeholder': 'eg. Category or Project name',
  'product-lists.create-modal-visibility-label': 'Visibility',
  'product-lists.create-modal-cta': 'CREATE AND ADD TO',
  'product-lists.create-modal-close': 'Close modal',
  'product-lists.create-modal-clear-input': 'Clear input',
  'product-lists.visibility-group-label': 'Content Visibility',
  'product-lists.visibility-private': 'Private',
  'product-lists.visibility-private-help': 'Just for you',
  'product-lists.visibility-public': 'Public',
  'product-lists.visibility-public-help': 'Anyone can view',
  // ChangeFavoriteListModal microcopy
  'product-lists.change-modal-title': 'Change list',
  'product-lists.change-modal-subtitle': 'Add to existing or a new list',
  'product-lists.change-modal-title-from-create': 'Add to list',
  'product-lists.change-modal-subtitle-from-create':
    'Add to a new or change to an existing list',
  'product-lists.change-modal-assets': 'assets',
  'product-lists.change-modal-assets_singular': 'asset',
  'product-lists.change-modal-private': 'Private',
  'product-lists.change-modal-public': 'Public',
  'product-lists.change-modal-default': 'Default list',
  'product-lists.change-modal-new': 'NEW LIST',
  'product-lists.change-modal-save': 'SAVE',
  'product-lists.change-modal-close': 'Close modal',
  'product-lists.change-modal-add': 'ADD TO',
  'product-lists.change-modal-personal': 'Personal Lists',
  'product-lists.change-modal-organization': 'Organization Lists',
  'product-lists.change-modal-tabs-aria': 'Lists navigation',
  'product-lists.create-modal-account-type-label': 'Account type',
  'product-lists.create-modal-account-type-personal': 'Personal',
  'product-lists.create-modal-account-type-organization': 'Organization',
  'product-lists.create-modal-account-type-aria': 'Account type',
} as const;

type MicrocopyMap = Record<string, string>;

export function buildCreateModalMicrocopy(
  mc: MicrocopyMap
): FavoriteListModalPropsMicrocopy {
  return {
    title: mc['product-lists.create-modal-title'],
    subTitle: mc['product-lists.create-modal-subtitle'],
    listNameLabel: mc['product-lists.create-modal-name-label'],
    listNamePlaceholder: mc['product-lists.create-modal-name-placeholder'],
    visibilityLabel: mc['product-lists.create-modal-visibility-label'],
    accountTypeLabel: mc['product-lists.create-modal-account-type-label'],
    visibility: {
      groupLabel: mc['product-lists.visibility-group-label'],
      private: mc['product-lists.visibility-private'],
      privateHelp: mc['product-lists.visibility-private-help'],
      public: mc['product-lists.visibility-public'],
      publicHelp: mc['product-lists.visibility-public-help'],
    },
    accountType: {
      ariaLabel: mc['product-lists.create-modal-account-type-aria'],
      personal: mc['product-lists.create-modal-account-type-personal'],
      organization: mc['product-lists.create-modal-account-type-organization'],
    },
    cta: mc['product-lists.create-modal-cta'],
    close: mc['product-lists.create-modal-close'],
    clearInput: mc['product-lists.create-modal-clear-input'],
    serverMessage: {
      title:
        mc['product-lists.create-modal-server-message-title'] ||
        'Network error',
      description:
        mc['product-lists.create-modal-server-message-description'] ||
        'A network or server error occurred. Please try again later.',
      dismiss:
        mc['product-lists.create-modal-server-message-dismiss'] || 'Dismiss',
    },
  };
}

export function buildChangeModalMicrocopy(
  mc: MicrocopyMap,
  isFromCreateFlow: boolean
): ChangeFavoriteListModalPropsMicrocopy {
  return {
    title: isFromCreateFlow
      ? mc['product-lists.change-modal-title-from-create']
      : mc['product-lists.change-modal-title'],
    subTitle: isFromCreateFlow
      ? mc['product-lists.change-modal-subtitle-from-create']
      : mc['product-lists.change-modal-subtitle'],
    assets: mc['product-lists.change-modal-assets'],
    assets_singular: mc['product-lists.change-modal-assets_singular'],
    private: mc['product-lists.change-modal-private'],
    public: mc['product-lists.change-modal-public'],
    default: mc['product-lists.change-modal-default'],
    new: mc['product-lists.change-modal-new'],
    add: mc['product-lists.change-modal-add'],
    save: mc['product-lists.change-modal-save'],
    close: mc['product-lists.change-modal-close'],
    personal: mc['product-lists.change-modal-personal'],
    organization: mc['product-lists.change-modal-organization'],
    tabsAriaLabel: mc['product-lists.change-modal-tabs-aria'],
    serverMessage: {
      title:
        mc['product-lists.change-modal-server-message-title'] ||
        'Network error',
      description:
        mc['product-lists.change-modal-server-message-description'] ||
        'A network or server error occurred. Please try again later.',
      additionalInfo:
        mc['product-lists.change-modal-server-message-additional-info'],
      cta: mc['product-lists.change-modal-server-message-cta'],
      dismiss:
        mc['product-lists.change-modal-server-message-dismiss'] || 'Dismiss',
    },
  };
}
